module.exports = __webpack_public_path__ + "img/icons8-search.22056921.svg";